import React from 'react'
import styles from './index.module.scss'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const AboutSection = () => {
    const corouselContent = [
        {
            id: 1,
            class: styles.bgImg1
        },
        {
            id: 2,
            class: styles.bgImg2
        },
        {
            id: 3,
            class: styles.bgImg3
        }
    ]

    return (
        <section className={styles.about_section} id="overview">
            <div className={styles.about_header}>
                <h2>About Our Ministry</h2>
            </div>
            <div className={styles.about_container}>
                <div className={styles.about_content}>
                    <h4>Who We Are</h4>
                    <p>
                        University Bible Fellowship (UBF) is an international evangelical church (non-denominational) dedicated to Christ and his kingdom. <br/> <br/>
                        Our main focus is to study the Bible, grow in the grace and knowledge of our Lord and Savior Jesus Christ, and live according to his teachings as his disciples. You can follow us on <a href='https://open.spotify.com/show/0tZOb8boeX30JgHAUY3SZZ?si=IHDa118RReewie_Mop6fPA'>spotify</a> to listen to our audio messages. <br/> <br/>
                        We especially pray to reach University and College students and help them grow as Christ's lifelong disciples. Our goal is to obey our Lord’s commands to love one another and to go and make disciples of all nations (Jn 13:34; Mt 28:18-20)
                    </p>
                </div>
            </div>
            <div className={styles.about_header}>
                <h2>About Easter Conference</h2>
            </div>
            <div className={styles.about_conference}>
                <Carousel 
                    showThumbs={false} 
                    autoPlay={true} 
                    interval={3000} 
                    transitionTime={1500}
                    infiniteLoop={true}
                    showArrows={false}
                    showIndicators={false}
                    showStatus={false}
                    stopOnHover={false}
                    swipeable={false}
                    animationHandler='fade'
                >
                    {
                        corouselContent.map((content) => (
                            <div key={content.id} className={`${styles.about_conference_container} ${content.class}`}>
                                <div className={styles.about_conference_content}>
                                    <h3>Easter Conference 2026</h3>
                                    <p>
                                        Easter reminds us of the ultimate victory of Jesus Christ over death, 
                                        and the hope of eternal life granted to all who believe in Him. This year at the University 
                                        Bible Fellowship Easter Conference, we focus on answering God’s call as revealed in Isaiah 6:8: 
                                        “Here am I; send me.” Our theme, “The Vision”, captures the call to be ready, willing, and 
                                        obedient to God’s purposes in our lives. Just as Isaiah saw God’s glory and responded with 
                                        courage, we are challenged to open our hearts to His vision, step into His calling, and be 
                                        instruments of His Kingdom here on earth.
                                    </p>
                                </div>
                            </div>
                        ))
                    }
                </Carousel>
            </div>
        </section>
    )
}

export default AboutSection